<div class="cnt-column-centered" data-testid="createPlanLoaderPopup">
    <div [height]="20"></div>
    <div class="h1Font b3Color" i18n>{{ 'NEARLY_THERE_JUST_SETTING' | translate }}</div>
    <div [height]="20"></div>
    <div class="p1Font b1Color" i18n>
        {{ 'WE_ARE_IMPORTING_YOUR' | translate }}<br />
        {{ 'A_LOT_OF_DATA' | translate }}
    </div>
    <div [height]="50"></div>

    <div class="ldio-ty68crv3j7">
        <div></div>
    </div>
</div>